const CD_GESTOR_API = 'API';
const GESTOR_API = {
	codigo: CD_GESTOR_API,
	nome: 'Gestor de API'
}

const CD_GESTOR_ARQUIVO_GV = 'AGV';
const GESTOR_ARQUIVO_GV = {
	codigo: CD_GESTOR_ARQUIVO_GV,
	nome: 'Gestor de Arquivo GV'
}

export { CD_GESTOR_API, GESTOR_API, CD_GESTOR_ARQUIVO_GV, GESTOR_ARQUIVO_GV }
